import { ReactElement } from 'react';
import styles from './selectorHeader.module.scss';

export const RadioSelectorHeader = (): ReactElement => {
    return <div className={styles.container} />;
};
